import { UIHeading2, UIText1 } from '@cian/ui-kit';
import { IUseGetDiffReturnValue } from './useGetDiff';

interface IUseGetInfoProps {
  isLoading: boolean;
  averageSqmPrice?: string;
  averagePrice?: string;
  isRoomsCountAll: boolean;
  type: EGetInfo;
  differencePrice?: IUseGetDiffReturnValue;
}

export enum EGetInfo {
  PriceAverage = 'priceAverage',
  PriceChange = 'priceChange',
}
export function useGetInfo({
  isLoading,
  isRoomsCountAll,
  averageSqmPrice,
  averagePrice,
  type,
  differencePrice,
}: IUseGetInfoProps) {
  const skeleton = '—';
  if (isLoading) {
    return skeleton;
  }
  if (type === EGetInfo.PriceAverage) {
    if (isRoomsCountAll) {
      return <UIHeading2>{averageSqmPrice}</UIHeading2>;
    } else {
      return (
        <>
          <UIHeading2>{averagePrice}</UIHeading2>
          <UIText1>{averageSqmPrice}</UIText1>
        </>
      );
    }
  } else {
    return (
      <>
        <UIHeading2>{differencePrice?.text}</UIHeading2>
        {differencePrice?.icon}
        <UIHeading2 color="primary_100">{differencePrice?.diffPercent}</UIHeading2>
      </>
    );
  }
}
